/* ARGENT theme — interactions */
(function(){
  // mobile menu
  var hdr=document.querySelector('.site-header'), burger=document.querySelector('.burger');
  if(burger){burger.addEventListener('click',function(){hdr.classList.toggle('open');});}
  document.querySelectorAll('.site-nav a').forEach(function(a){a.addEventListener('click',function(){hdr&&hdr.classList.remove('open');});});

  // reveal on scroll
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12});
    document.querySelectorAll('.reveal').forEach(function(el,i){el.style.transitionDelay=(i%4*60)+'ms';io.observe(el);});
  } else {
    document.querySelectorAll('.reveal').forEach(function(el){el.classList.add('in');});
  }

  // toast helper
  window.argentToast=function(msg){
    var t=document.getElementById('toast'); if(!t){t=document.createElement('div');t.id='toast';t.className='toast';document.body.appendChild(t);}
    t.textContent=msg; t.classList.add('show'); clearTimeout(window.__tt); window.__tt=setTimeout(function(){t.classList.remove('show');},3400);
  };

  // product variant selection
  var form=document.querySelector('.product-form');
  if(form){
    var data=document.getElementById('product-variants-json');
    var variants=data?JSON.parse(data.textContent):[];
    var selects=form.querySelectorAll('[data-option]');
    var idInput=form.querySelector('[name="id"]');
    var priceEl=document.querySelector('[data-price]');
    var btn=form.querySelector('[data-add]');
    function money(c){return '$'+(c/100).toFixed(2);}
    function update(){
      var chosen=Array.prototype.map.call(selects,function(s){return s.value;});
      var v=variants.find(function(x){return x.options.join(' / ')===chosen.join(' / ');})||variants[0];
      if(!v)return;
      idInput.value=v.id;
      if(priceEl)priceEl.firstChild&&(priceEl.childNodes[0].nodeValue=money(v.price)+' ');
      if(btn){btn.disabled=!v.available;btn.textContent=v.available?btn.dataset.add:'Sold out';}
    }
    selects.forEach(function(s){s.addEventListener('change',update);});
    update();
  }

  // product gallery thumbs
  document.querySelectorAll('[data-thumb]').forEach(function(th){
    th.addEventListener('click',function(){
      var main=document.querySelector('[data-main-image]'); if(main){main.src=th.dataset.full||th.src;}
    });
  });

  // contact section (non-Shopify enquiry helper) toast on submit handled by Shopify redirect; nothing needed
})();
